import React, { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/system";
import SoftButton from "components/SoftButton";

import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

import { postData, putData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

import { useSoftUIController } from "context";

// sweetalert2 components
import Swal from "sweetalert2";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

let translationsChanges = [];
function EditTranslations({ showModal, signalCloseModal, data, entity }) {
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;

  const [translations, setTranslations] = useState([]);
  const [open, setOpen] = useState(false);
  const [resetTranslations, setResetTranslations] = useState([]);
  const [dataEntity, setDataEntity] = useState(null);
  const [uniId, setUniId] = useState(0);
  const [originalName, setOriginalName] = useState("");
  const [sportName, setSportName] = useState("");
  const [regionName, setRegionName] = useState("");
  const [typeName, setTypeName] = useState("");
  const [translationsArray, setTranslationsArray] = useState([]);
  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [platform_id, setPlatformId] = useState(null);

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const handleCancelEdit = () => {
    if (translationsChanges.length > 0 || resetTranslations.length > 0) {
      Swal.fire({
        title: `Unsaved Data!`,
        html: `You are going Lose some Translations.
          </br></br>
          Are you Sure?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes, Cancel them!",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setResetTranslations([]);
          setOpen(false);
          signalCloseModal(false, null);
          setTranslationsArray([]);
          setTranslations([]);
          translationsChanges = [];
        }
      });
    } else {
      setResetTranslations([]);
      setOpen(false);
      signalCloseModal(false, null);
      setTranslationsArray([]);
      setTranslations([]);
      translationsChanges = [];
    }
  };

  const handleUpdate = async () => {
    Swal.fire({
      title: `Update Translations`,
      html: `You are going to Update the Selected Translations. \nAre you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "success",
      // denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (resetTranslations.length > 0) {
          resetTranslations.forEach((element) => {
            let itemFound = translationsChanges.find((item) => item.lang == element);
            if (itemFound) {
              itemFound.trans = "reset";
            } else {
              translationsChanges.push({ lang: element, trans: "reset" });
            }
          });
        }

        let objToSend = {
          lang: "multi",
          platform_id: platform_id,
          original: originalName,
          translation: translationsChanges,
          uni_id: uniId,
        };

        let updateSportsTranslationsEndpoint = null;

        switch (dataEntity) {
          case "sport":
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientsports`;
            break;
          case "region":
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientregions`;
            break;
          case "competition":
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientcompetitions`;
            break;
          case "participant":
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientparticipants`;
            break;
          case "market":
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientmarkets`;
            break;
          default:
            updateSportsTranslationsEndpoint = `/api/v1/translations/clientsports`;
            break;
        }

        let response = false;

        if (
          objToSend.lang &&
          objToSend.translation &&
          objToSend.original &&
          objToSend.platform_id &&
          objToSend.uni_id &&
          translationsChanges.length > 0
        ) {
          response = await putData(updateSportsTranslationsEndpoint, objToSend, {
            Authorization: getAuthorizationHeader(),
          });
        }

        if (response) {
          setApiresponse("success");
          setApiResponseMsg("Translations Updated");
          setNotification(true);
          setOpen(false);
          signalCloseModal(true);
        } else {
          setApiresponse("error");
          setApiResponseMsg("Something goes wrong. Try again later.");
          setNotification(true);
          setOpen(false);
          signalCloseModal(false);
        }

        setResetTranslations([]);
        setTranslationsArray([]);
        setTranslations([]);
        translationsChanges = [];
      }
    });
  };

  const handleResetTranslation = async (e, item) => {
    let objToSend = {
      lang_name: item.lang,
      original: originalName,
    };

    let updateSportsTranslationsEndpoint = null;

    switch (dataEntity) {
      case "sport":
        updateSportsTranslationsEndpoint = `/api/v1/translations/clientsportlang`;
        break;
      case "region":
        updateSportsTranslationsEndpoint = `/api/v1/translations/clientregionlang`;
        break;
      case "competition":
        objToSend.sport = sportName;
        updateSportsTranslationsEndpoint = `/api/v1/translations/clientcompetitionlang`;
        break;
      case "participant":
        objToSend.sport = sportName;
        objToSend.uni_id = uniId;
        updateSportsTranslationsEndpoint = `/api/v1/translations/clientparticipantlang`;
        break;
      case "market":
        objToSend.sport = sportName;
        objToSend.uni_id = uniId;
        updateSportsTranslationsEndpoint = `/api/v1/translations/clientmarketlang`;
        break;
      default:
        break;
    }

    let response = false;

    if (objToSend.lang_name && objToSend.original) {
      response = await postData(updateSportsTranslationsEndpoint, objToSend, {
        Authorization: getAuthorizationHeader(),
      });
    }

    if (response == null) {
      setApiresponse("error");
      setApiResponseMsg("Something goes wrong! Try again later.");
      setNotification(true);
      return;
    }
    if (Object.entries(response.data).length > 0) {
      let entry = Object.entries(response.data)[0];
      item.trans = entry[1][item.lang];

      setTranslationsArray([]);
      await sleep(100);
      let transArray = [...translationsArray];

      let itemTochange = transArray.find((trans) => trans.lang == item.lang);
      itemTochange.trans = entry[1][item.lang];

      setTranslationsArray(transArray);

      let tmpResetTranslations = [...resetTranslations];
      let tmpResetTranslation = tmpResetTranslations.find((trans) => trans == item.lang);
      if (!tmpResetTranslation) {
        tmpResetTranslations.push(item.lang);
      } else {
        tmpResetTranslation = item.lang;
      }
      //console.log(response.data);
      setResetTranslations(tmpResetTranslations);
      setApiresponse("success");
      setApiResponseMsg("Original Translation Loaded.");
      setNotification(true);
    } else {
      setApiresponse("error");
      setApiResponseMsg("There are NO Original Translation.");
      setNotification(true);
      return;
    }
    //console.log(data);
    let tmpTranslations = {};

    Object.keys(translations).forEach((key) => {
      tmpTranslations[key] = key == 1 ? { ...translations[key] } : translations[key];
    });

    tmpTranslations[item.lang.toLowerCase()] = item.trans;
    tmpTranslations[1][item.lang] = item.trans;

    setTranslations(tmpTranslations);
  };

  function updateData(e, data) {
    e.preventDefault();
    let dataupdated = false;
    let translationChangedSelected = translationsChanges.find((item) => item.lang == data.lang);
    if (!translationChangedSelected) {
      if (e.currentTarget.value != data.trans) {
        //console.log("translation changed");
        translationsChanges.push({ lang: data.lang, trans: e.currentTarget.value });
        dataupdated = true;
      } else {
        //console.log("translation doesnt change");
      }
    } else {
      if (e.currentTarget.value != translationChangedSelected.trans) {
        //console.log("translation updated");
        translationChangedSelected.trans = e.currentTarget.value;
        dataupdated = true;
      }
    }
    if (dataupdated) {
      let tmpResetTranslations = [...resetTranslations];
      let tmpResetTranslationIndex = tmpResetTranslations.findIndex((trans) => trans == data.lang);
      if (tmpResetTranslationIndex > -1) tmpResetTranslations.splice(tmpResetTranslationIndex, 1);
      setResetTranslations(tmpResetTranslations);
    }
  }

  function renderTranslationsData(data) {
    if (!data || data.length == 0) return "";

    return translationsArray.map((item) =>
      item.lang != "uni_id" ? (
        <Grid key={item.lang + "-grid"} item xs={6}>
          <div key={item.lang + "-holder"} style={{ color: "#344767" }}>
            <SoftTypography key={item.lang + "-lang-name"} variant="label" className="form-label">
              {item.lang}
            </SoftTypography>
            <Grid container spacing={1}>
              <Grid item xs={10}>
                <SoftInput
                  key={item.lang + "-trans-" + item.trans}
                  defaultValue={item.trans}
                  size="small"
                  onBlur={(e) => updateData(e, item)}
                  onChange={(e) => updateData(e, item)}
                />
                <SoftTypography
                  variant="label"
                  className="form-info"
                  style={{ display: resetTranslations.indexOf(item.lang) > -1 ? "" : "none" }}
                >
                  will be reset to original translation
                </SoftTypography>
              </Grid>
              <Grid item xs={2}>
                <HtmlTooltip placement="right" title="Reset to Original">
                  <Button
                    style={{ width: "10px", height: "10px", minWidth: "10px" }}
                    onClick={(e) => handleResetTranslation(e, item)}
                  >
                    <Icon>rotate_left_outlined_icon</Icon>
                  </Button>
                </HtmlTooltip>
              </Grid>
            </Grid>
          </div>
        </Grid>
      ) : null
    );
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  useEffect(() => {
    setPlatformId(platform.value);
  }, [platform.label]);

  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  useEffect(() => {
    if (data) {
      setTranslations(data);
      let original = data ? data[0] : "";
      let uni_id = data[1].uni_id;
      let sport = null;
      let region = null;
      let type = null;
      setUniId(uni_id);
      if (data.length > 0 && data[1].original) original = data[1].original;
      setOriginalName(original);
      if (data.length > 0 && data[1].sport) sport = data[1].sport;
      setSportName(sport);
      if (data.length > 0 && data[1].region) region = data[1].region;
      setRegionName(region);
      if (data.length > 0 && data[1].type) type = data[1].type;
      setTypeName(type);
    }
  }, [data]);

  useEffect(() => {
    if (entity) setDataEntity(entity);
  }, [entity]);

  useEffect(() => {
    if (translations.length == 0) return;
    let transArray = [];

    Object.keys(translations[1]).forEach((element) => {
      if (
        element != "sport" &&
        element != "region" &&
        element != "type" &&
        element != "original" &&
        element != "uni_id"
      )
        transArray.push({ lang: element, trans: translations[1][element] });
    });

    setTranslationsArray(transArray);
  }, [translations]);

  useEffect(() => {
    return () => {
      setResetTranslations([]);
      setOpen(false);
      setTranslationsArray([]);
      setTranslations([]);
      translationsChanges = [];
    };
  }, []);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <Dialog open={open} onClose={handleCancelEdit} fullWidth={true} maxWidth={"md"}>
        <DialogTitle>
          <Grid container spacing={3}>
            <Grid
              container
              item
              xs={12}
              style={{ flexDirection: "row-reverse", paddingRight: "15px" }}
            >
              <SoftTypography
                style={{
                  color: "rgba(0, 0, 0, 0.60)",
                  paddingLeft: "5px",
                  display: typeName ? "" : "none",
                }}
              >
                {typeName},{" "}
              </SoftTypography>
              <SoftTypography
                style={{
                  color: "rgba(0, 0, 0, 0.60)",
                  paddingLeft: "5px",
                  display: regionName ? "" : "none",
                }}
              >
                {regionName},{" "}
              </SoftTypography>
              <SoftTypography
                style={{ color: "rgba(0, 0, 0, 0.60)", display: sportName ? "" : "none" }}
              >
                {sportName},{" "}
              </SoftTypography>
            </Grid>

            <Grid item xs={6} style={{ textTransform: "capitalize", paddingTop: "0px" }}>
              Edit Translations for {dataEntity}:
            </Grid>
            <Grid
              item
              xs={6}
              style={{ textAlign: "right", paddingRight: "15px", paddingTop: "0px" }}
            >
              <SoftTypography style={{ color: "#cb0c9f" }}>{originalName}</SoftTypography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} alignItems="center">
            {translations ? renderTranslationsData(translations) : ""}
          </Grid>
          <div
            style={{
              display: translationsArray.length > 0 ? "none" : "block",
              minHeight: "200px",
              textAlign: "center",
              margin: "auto",
              lineHeight: "200px",
            }}
          >
            loading...
          </div>
        </DialogContent>
        <DialogActions>
          <SoftButton variant="outlined" size="small" color="info" onClick={handleCancelEdit}>
            Cancel
          </SoftButton>
          <SoftButton
            variant="gradient"
            size="small"
            color={translationsArray.length > 0 ? "dark" : "light"}
            disabled={translationsArray.length > 0 ? false : true}
            onClick={handleUpdate}
          >
            Update
          </SoftButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
EditTranslations.defaultProps = {
  showModal: false,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
EditTranslations.propTypes = {
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
  data: PropTypes.array,
  entity: PropTypes.string,
};

export default EditTranslations;
